<template>
  <div>
    <form action="">
      <v-card class="mb-4 pb-2" v-for="(card, index) in cards" :key="index">
        <v-toolbar dense elevation="0">
          <v-toolbar-title class="subtitle-1">{{
            card.titleCard
          }}</v-toolbar-title>
        </v-toolbar>
        <v-divider></v-divider>
        <v-row
          class="align-center pl-4 pr-4"
          v-for="(row, indexRow) in card.rows"
          :key="indexRow"
        >
          <v-col cols="12 pb-0">
            <div class="d-flex overline justify-start align-center">
              <div class="grey--text">
                {{ row.titleRow }}
              </div>
              <v-divider class="ml-4"></v-divider>
            </div>
          </v-col>

          <v-col
            class=""
            v-for="(col, indexCol) in row.cols"
            :key="indexCol"
            :cols="getCols(row.cols)"
          >
            <div>
              <div class="pb-2 subtitle-2">
                {{ col.label }}
                <v-tooltip top v-if="col.tips">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn small icon v-bind="attrs" v-on="on">
                      <v-icon small color="info">
                        mdi-information-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ infoKey(col.field.name) }}</span>
                </v-tooltip>
              </div>
              <v-text-field
                v-if="col.field.type == 'text'"
                type="text"
                v-model="col.field.model"
                @keypress="isNumber($event)"
                @change="formatDecimal(col.field)"
                :name="col.field.name"
                :append-icon="col.field.icon"
                :prepend-icon="col.field.icon"
                solo-inverted
                required
                dense
                hide-details="auto"
                class="subtitle-2"
              ></v-text-field>

              <v-select
                v-model="col.field.model"
                v-if="col.field.type == 'select'"
                :items="col.field.items"
                item-text="text"
                item-value="value"
                label="Selecione"
                solo-inverted
                dense
                hide-details
                class="subtitle-2"
              ></v-select>

              <v-textarea
                v-if="col.field.type == 'textarea'"
                v-model="col.field.model"
                class="pre-formatted subtitle-2"
                :name="col.field.name"
                height="300"
                no-resize
                solo
                light
              ></v-textarea>
              <v-text-field
                v-if="col.field.type == 'number'"
                type="number"
                v-model="col.field.model"
                @keypress="isNumber($event)"
                :name="col.field.name"
                :append-icon="col.field.icon"
                :prepend-icon="col.field.icon"
                solo-inverted
                required
                dense
                hide-details
                class="subtitle-2"
              ></v-text-field>
            </div>
          </v-col>
        </v-row>
      </v-card>

      <v-card class="d-flex justify-end">
        <div class="pa-4">
          <v-btn small class="ml-2 white black--text" @click="getDataBank">{{
            $t("toCancel")
          }}</v-btn>
          <v-btn small class="ml-2 info" @click="submit">{{
            $t("toSave")
          }}</v-btn>
        </div>
      </v-card>
    </form>
  </div>
</template>

<script>
export default {
  name: "",
  data: () => ({
    models: [],
    cards: [],
  }),

  computed: {
    card() {
      return [
        {
          titleCard: this.$t("generalSettingsAgents"),
          rows: [
            {
              titleRow: this.$t("cancellationOfBetByAgent"),
              cols: [
                {
                  label: this.$t("cancelBet"),
                  field: {
                    name: "cancel_bet",
                    model: "",
                    type: "select",
                    items: [
                      {
                        text: "Sim",
                        value: "1",
                      },
                      {
                        text: "Não",
                        value: "0",
                      },
                    ],
                    icon: "",
                  },
                },
                {
                  label: this.$t("minutesToCancel"),
                  field: {
                    name: "minutes_cancellation",
                    model: "",
                    type: "text",
                    icon: "",
                  },
                },
              ],
            },
            {
              titleRow: "Validar Aposta",
              cols: [
                {
                  label: this.$t("originalTimeOdds"),
                  tips: true,
                  field: {
                    name: "tempo_cotacao_original",
                    model: "",
                    type: "text",
                    icon: "",
                  },
                },
              ],
            },
          ],
        },
        {
          titleCard: this.$t("generalSettingsPortal"),
          rows: [
            {
              titleRow: this.$t("portalOptions"),
              cols: [
                {
                  label: this.$t("acceptPreBet"),
                  field: {
                    name: "pre_bet",
                    model: "",
                    icon: "",
                    type: "select",
                    items: [
                      {
                        text: "Sim",
                        value: "1",
                      },
                      {
                        text: "Não",
                        value: "0",
                      },
                    ],
                  },
                },
                {
                  label: this.$t("activateLiveModule"),
                  field: {
                    name: "module_live",
                    model: "",
                    type: "select",
                    items: [
                      {
                        text: "Sim",
                        value: "1",
                      },
                      {
                        text: "Não",
                        value: "0",
                      },
                    ],
                  },
                },
                {
                  label: this.$t("showMainEvents"),
                  field: {
                    name: "main_events",
                    model: "",
                    type: "select",
                    items: [
                      {
                        text: "Sim",
                        value: "1",
                      },
                      {
                        text: "Não",
                        value: "0",
                      },
                    ],
                  },
                },
                {
                  label: this.$t("minutesAllowrdOnLive"),
                  field: {
                    name: "minutes_live",
                    model: "",
                    type: "text",
                    icon: "",
                  },
                },
              ],
            },
          ],
        },
        {
          titleCard: this.$t("generalSettingsBanking"),
          rows: [
            {
              titleRow: this.$t("controlOfLimits"),
              cols: [
                {
                  label: this.$t("numbersOfDaysInTable"),
                  field: {
                    name: "days_table",
                    model: "",
                    type: "text",
                    icon: "",
                  },
                },
                {
                  label: this.$t("maximumEventsPerBet"),
                  tips: true,
                  field: {
                    name: "max_events",
                    model: "",
                    type: "text",
                    icon: "",
                  },
                },
                {
                  label: this.$t("maximumBankingAward"),
                  field: {
                    name: "max_prize",
                    model: "",
                    type: "text",
                    icon: "",
                    isDecimal: true,
                  },
                },
                {
                  label: this.$t("minimumBetAmount"),
                  tips: true,
                  field: {
                    name: "min_bet",
                    model: "",
                    type: "text",
                    icon: "",
                    isDecimal: true,
                  },
                },
                {
                  label: this.$t("maximumValueOfBet"),
                  field: {
                    name: "max_bet",
                    model: "",
                    type: "text",
                    icon: "",
                    isDecimal: true,
                  },
                },
                {
                  label: this.$t("minimumMultiplierForABet"),
                  field: {
                    name: "min_multi",
                    model: "",
                    type: "text",
                    icon: "",
                    isDecimal: true,
                  },
                },
                {
                  label: this.$t("maximumMultiplierForABet"),
                  field: {
                    name: "max_multi",
                    model: "",
                    type: "text",
                    icon: "",
                    isDecimal: true,
                  },
                },
                {
                  // Revisar
                  label: this.$t("doNotDisplayQuotesBelow"),
                  field: {
                    name: "min_odd",
                    model: "",
                    type: "text",
                    icon: "",
                    isDecimal: true,
                  },
                },
              ],
            },
            // Nova row que separa a section limites de mercado
            {
              titleRow: this.$t("marketLimits"),
              cols: [
                {
                  label: this.$t("maximumLimitByMarketOnEvent"),
                  tips: true,
                  field: {
                    name: "limit_event_type",
                    model: "",
                    type: "text",
                    icon: "",
                    isDecimal: true,
                  },
                },
                {
                  label: this.$t("percentUserCanHighLimit"),
                  tips: true,
                  field: {
                    name: "factor_user",
                    model: "",
                    type: "text",
                    icon: "",
                    isDecimal: true,
                  },
                },
              ],
            },
            {
              titleRow: this.$t("PRINT"),
              cols: [
                {
                  label: this.$t("commentsLabel"),
                  field: {
                    name: "observation",
                    model: "",
                    type: "textarea",
                    icon: "",
                    isDecimal: false,
                  },
                },
              ],
            },
            {
              titleRow: this.$t("reulationForThePortal"),
              cols: [
                {
                  label: "",
                  field: {
                    name: "regulation",
                    model: "",
                    type: "textarea",
                    icon: "",
                    isDecimal: false,
                  },
                },
              ],
            },
          ],
        },
      ];
    },
  },

  created() {
    this.getDataBank();
    this.cards = this.card;
  },

  methods: {
    async getDataBank() {
      const request = await this.$request.get(
        "/administrator/operator/getConfig"
      );
      // request.dados.regulation = request.dados.regulation.replace(/(\\r)*\\n/g, '</br>')
      // request.dados.observation = request.dados.regulation.replace(/(\\r)*\\n/g, '</br>')

      for (let card of this.cards) {
        for (let row of card.rows) {
          for (let col of row.cols) {
            col.field.model = request.dados[col.field.name];
            if (col.field.name == "factor_user") {
              col.field.model = (col.field.model * 100).toFixed(2);
            }
            if (col.field.name == "min_bet") {
              this.currentMinBetValue = request.dados[col.field.name];
            }
          }
        }
      }
    },

    // Colocalem formato decimal
    formatDecimal(field) {
      if (!field.isDecimal) return;
      field.model = Number(field.model.replace(",", ".")).toFixed(2);
    },

    // Verifica se é numero
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    getCols(cols) {
      return this.$vuetify.breakpoint.xs
        ? 12
        : cols.length >= 3
        ? 3
        : 12 / cols.length;
    },

    // Submit
    async submit() {
      const body = {};
      const data = this.cards
        .map((item) => item.rows)
        .reduce((a, b) => [...a, ...b])
        .map((item) => item.cols)
        .reduce((a, b) => [...a, ...b]);

      for (let item of data) {
        body[item.field.name] = item.field.model;
        if (item.field.name === "factor_user") {
          body[item.field.name] = item.field.model / 100;
        }
      }

      const postDataBank = await this.$request.post(
        "/administrator/operator/editConfig",
        body
      );
      if (postDataBank.length == 0) return;

      this.$store.commit("setMainEvents", body.main_events);

      this.$store.commit("setFeedbackSnack", {
        msg: postDataBank.messages,
        color: "success",
      });
    },
    infoKey: function(key) {
      const info = {
        max_events: this.$t("eventsPerBetHint"),
        limit_event_type: this.$t("maximumLimitByMarketOnEventTip"),
        factor_user: this.$t("percentUserCanHighLimitTip"),
        tempo_cotacao_original: this.$t("originalTimeOddsTip"),
        min_bet: this.$t("valueMinAccepted"),
      };

      return info[key] || null;
    },
  },
};
</script>

<style scoped>
.pre-formatted {
  white-space: pre;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
